import { FC} from 'react'
import iconDialogo from '../../../../assets/iconos/iconDialogo.png'
import iconCelu from '../../../../assets/iconos/iconCelu.png'
import iconUbicacion from '../../../../assets/iconos/iconUbicacion.png'
//import { ReactComponent as IsoLogo } from '../../../../assets/isoLogo1.svg'
//import { ReactComponent as LogoLuca } from '../../../../assets/logoLuca.svg'
import { Outlet } from 'react-router-dom'
import imagen from '../../../../assets/businessInsights/tryluca-home-hero-1.png'
import logoLuca from '../../../../assets/logoNuevo/003 Logo blanco.svg'
import './LoginLayout.css'

export const AuthLayout: FC = () => {
  return (
    <div className="font-sans min-h-screen bg-gradient-to-br from-primary via-primary to-accent2 lg:bg-slate-100">
      <div className="flex flex-col lg:flex-row w-full min-h-screen">
        
        {/* HEADER MOBILE */}
        <div className="relative overflow-hidden text-white lg:hidden h-[140px]">

          <div className="relative z-10 flex items-center justify-center h-full px-6">
            <img
              src={logoLuca}
              className="w-72 sm:w-72 opacity-90"
              alt="Logo Luca"
            />
          </div>
        </div>

        {/* IZQUIERDA / FORMULARIO */}
        <div className="auth-left w-full lg:w-2/3 flex items-center justify-center bg-transparent lg:bg-white px-6 sm:px-10 lg:px-16 py-10">
          <div className="w-full max-w-xl">
            <Outlet />
          </div>
        </div>

        {/* DERECHA DESKTOP */}
        <div className="hidden lg:flex lg:w-1/3 relative overflow-hidden text-white auth-right-wrapper">
          <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-accent2" />
          <div className="absolute top-[-10%] right-[-10%] w-[35vw] h-[35vw] bg-blue-400/30 blur-3xl rounded-full" />

          <div className="relative z-10 flex flex-col w-full h-full px-6 xl:px-16 py-16 justify-between auth-right">

            {/* BLOQUE SUPERIOR: logo + frase */}
            <div className="flex flex-col items-center gap-8 auth-space">
              <img src={logoLuca} className="w-40 xl:w-56 opacity-90 auth-logo" alt="Logo Luca" />

              <p className="text-white/90 text-3xl font-medium leading-snug text-center px-4 auth-text-frase">
                La pieza que le falta a tu gestión financiera
              </p>
            </div>

            {/* BLOQUE CENTRAL: imagen + features */}
            <div className="flex flex-col items-center gap-16 auth-space">

              {/* Imagen */}
              <div className="relative flex items-center justify-center w-full max-w-xl">
                <div className="absolute w-full h-full bg-white/10 blur-3xl rounded-full opacity-30" />
                <div className="absolute w-[90%] h-[60%] bg-white/10 backdrop-blur-xl rounded-3xl border border-white/10 shadow-2xl" />

                <img
                  src={imagen}
                  className="relative z-10 w-full max-w-lg drop-shadow-2xl auth-image"
                  alt="Ilustración"
                />
              </div>

              {/* Features */}
              <div className="space-y-4 text-center w-full max-w-sm">
                <div className="flex items-center justify-center gap-3 px-4 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/10 shadow-lg auth-feature">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent2 text-sm">
                    ✓
                  </span>
                  <span className="text-base xl:text-lg font-semibold">
                    Clasificación automática
                  </span>
                </div>

                <div className="flex items-center justify-center gap-3 px-4 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/10 shadow-lg auth-feature">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent2 text-sm">
                    ✓
                  </span>
                  <span className="text-base xl:text-lg font-semibold">
                    Conciliación bancaria
                  </span>
                </div>

                <div className="flex items-center justify-center gap-3 px-4 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/10 shadow-lg auth-feature">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent2 text-sm">
                    ✓
                  </span>
                  <span className="text-base xl:text-lg font-semibold">
                    Generación de estados financieros
                  </span>
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="text-xs xl:text-sm text-white/70 flex items-center justify-center gap-8 text-center">
              <div className="flex flex-col">
                <p>soporte@tryluca.com</p>
              </div>

              <div className="flex flex-col">
                <p>Las Condes, Santiago</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ContactInfo: FC = () => (
  <div className='flex flex-col gap-9  mb-20'>
    <div className='flex gap-2 items-center'>
      <img className='w-12 h-12' src={iconDialogo} alt='iconUbicacion' />
      <div>
        <p className='font-bold uppercase'>hablemos</p>
        <p>soporte@tryluca.com</p>
      </div>
    </div>

    <div className='flex gap-2 items-center'>
      <img className='w-12 h-12' src={iconCelu} alt='iconUbicacion' />
      <div>
        <p className='font-bold uppercase'>llamanos</p>
        <p>+56 9 8662 5874</p>
      </div>
    </div>

    <div className='flex gap-2 items-center'>
      <img className='w-12 h-12' src={iconUbicacion} alt='iconUbicacion' />
      <div>
        <p className='font-bold uppercase'>visitanos</p>
        <p>
          Santa Magdalena 75, <br /> Providencia Santiago <br />
          Chile.
        </p>
      </div>
    </div>
  </div>
)

export const SecurityTSL: FC = () => (
  <div>
    <p>Ingresa los datos del SII para que Luca haga su magia..</p>
    <img src={imagen} />
  </div>
)
